import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { EngagementProvider } from "./contexts/EngagementContext";
import { CampaignPreferencesProvider } from "./contexts/CampaignPreferencesContext";
import { ApprovedContactsProvider } from "./contexts/ApprovedContactsContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import { SearchModeProvider } from "./contexts/SearchModeContext";
import { FieldVisibilityProvider } from "./contexts/FieldVisibilityContext";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals"; // REMOVED: File missing, not essential

// Auth0Provider with redirect callback for React Router
const Auth0ProviderWithRedirectCallback = ({ children, ...props }) => {
  const navigate = useNavigate();
  const onRedirectCallback = (appState) => {
    navigate((appState && appState.returnTo) || window.location.pathname);
  };
  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
};

const router = createBrowserRouter(
  [
    {
      path: "*",
      element: (
        <Auth0ProviderWithRedirectCallback
          domain={process.env.REACT_APP_AUTH0_DOMAIN}
          clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
          authorizationParams={{
            redirect_uri: window.location.origin,
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: "openid profile email",
          }}
        >
          <AuthProvider>
            <EngagementProvider>
              <SubscriptionProvider>
                <SearchModeProvider>
                  <CampaignPreferencesProvider>
                    <ApprovedContactsProvider>
                      <FieldVisibilityProvider>
                        <App />
                      </FieldVisibilityProvider>
                    </ApprovedContactsProvider>
                  </CampaignPreferencesProvider>
                </SearchModeProvider>
              </SubscriptionProvider>
            </EngagementProvider>
          </AuthProvider>
        </Auth0ProviderWithRedirectCallback>
      ),
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(); // REMOVED: File missing, not essential
